import { ActivatedRouteSnapshot } from '@angular/router';

import { Location } from 'src/app/models/location.model';

export type SidebarContentType = 'cart' | 'gift-card' | 'request-appointment';
export type HeaderContentType = 'cart' | 'gift-card';

let hasForcedDigitalServiceMenuMode = false;

export function isDigitalServiceMenuMode(location?: Location): boolean {
  if (globalThis.location?.search) {
    const params = new URLSearchParams(globalThis.location.search);
    if (params.get('test-digital-menu') === 'true') {
      hasForcedDigitalServiceMenuMode = true;
    }
  }

  return (
    hasForcedDigitalServiceMenuMode || (!!location?.widgetCustomSubdomainEnabled && !location?.onlineOrderingEnabled)
  );
}

export function hasRouteDataFlag(route: ActivatedRouteSnapshot, flag: string): boolean {
  if (route.data[flag]) {
    return true;
  }

  return route.children.some((childRoute) => hasRouteDataFlag(childRoute, flag));
}

export function hasGiftCardContent(route: ActivatedRouteSnapshot): boolean {
  return hasRouteDataFlag(route, 'showGiftCardContent');
}

export function getSidebarContentType(route: ActivatedRouteSnapshot, location?: Location): SidebarContentType {
  if (isDigitalServiceMenuMode(location)) {
    return 'request-appointment';
  }

  return hasGiftCardContent(route) ? 'gift-card' : 'cart';
}

export function getHeaderContentType(route: ActivatedRouteSnapshot): HeaderContentType {
  return hasGiftCardContent(route) ? 'gift-card' : 'cart';
}
